export function formatRandValue(dataValue: number) {
  if (dataValue) return dataValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return '';
}

export function formatPercentageOfBook(
  percentageOfBook: number | undefined,
  fractionDigits: number
) {
  if (!percentageOfBook) return '%';

  const percentage = percentageOfBook * 100;
  return percentage.toFixed(fractionDigits) + '%';
}
